import { DoorClosed, Search, ScanLine, Car, DoorOpen, Loader2, History, CircleDollarSign } from "lucide-react";
import { Input } from "@/components/ui/input";
import { sanitizeFolio } from "@/lib/utils";

// Bloque Salida / Cobro de vehículo + Ingreso por Pensión + acceso a Historial — presentacional.
export const SalidaCobroPanel = ({
  salidaInputRef, salidaQuery, setSalidaQuery, iniciarSalida,
  penIngreso, setPenIngreso, ingresoPension, penIngresando, abrirHistorial,
}) => (
  <div className="border-2 border-[#FFCC00]/60 bg-[#FFCC00]/5 p-5" data-testid="bloque-salida">
    <div data-testid="salida-panel">
      <p className="text-[11px] tracking-[0.15em] uppercase font-black text-[#FFCC00] mb-2 flex items-center gap-1.5">
        <DoorClosed className="h-4 w-4" /> Salida / Cobro de vehículo
      </p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#FFCC00] pointer-events-none" />
          <Input ref={salidaInputRef} value={salidaQuery}
            onChange={(e) => setSalidaQuery(sanitizeFolio(e.target.value))}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); iniciarSalida(); } }}
            placeholder="Folio o Placa..."
            data-testid="salida-search"
            className="h-14 pl-11 rounded-none bg-black/40 border-2 border-[#FFCC00] text-white font-display tracking-wider text-base placeholder:text-white/30 focus-visible:ring-2 focus-visible:ring-[#FFCC00] focus-visible:border-[#FFCC00]" />
        </div>
        <button onClick={iniciarSalida} data-testid="salida-buscar-btn"
          className="btn-hard h-14 px-5 bg-[#FFCC00] text-[#0A0A0A] border border-[#0A0A0A] font-black uppercase tracking-wider text-sm flex items-center gap-2 whitespace-nowrap">
          <CircleDollarSign className="h-5 w-5" /> Cobrar / Buscar
        </button>
      </div>
      <p className="mt-2 flex items-center gap-1.5 text-[11px] text-white/60 leading-snug" data-testid="salida-ayuda">
        <ScanLine className="h-3.5 w-3.5 text-[#FFCC00] shrink-0" /> Escanee el código de barras o escriba el folio / placa para cobrar
      </p>
      <p className="mt-1 flex items-center gap-1.5 text-[11px] font-bold tracking-wider text-[#34D399]" data-testid="salida-indicador">
        <span className="inline-block h-2 w-2 rounded-full bg-[#34D399] animate-pulse" /> Escáner listo · Búsqueda dual por Folio o Placa
      </p>
    </div>

    {/* Ingreso de pensionados por TAG / Placa */}
    <div className="mt-4 border border-white/15 bg-white/5 p-3" data-testid="pension-ingreso-panel">
      <p className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/50 mb-2 flex items-center gap-1.5"><Car className="h-3.5 w-3.5 text-[#FFCC00]" /> Ingreso por TAG / Placa (Pensión)</p>
      <div className="flex gap-2">
        <Input value={penIngreso} onChange={(e) => setPenIngreso(e.target.value.toUpperCase())}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); ingresoPension(); } }}
          placeholder="TAG o placa del pensionado" data-testid="pension-ingreso-input"
          className="h-11 rounded-none bg-white/5 border-white/20 text-white uppercase tracking-wider focus-visible:ring-2 focus-visible:ring-[#FFCC00]" />
        <button onClick={ingresoPension} disabled={penIngresando} data-testid="pension-ingreso-btn"
          className="btn-hard h-11 px-4 bg-[#FFCC00] text-[#0A0A0A] border border-[#0A0A0A] font-bold uppercase tracking-wider text-xs flex items-center gap-2 disabled:opacity-60">
          {penIngresando ? <Loader2 className="h-4 w-4 animate-spin" /> : <DoorOpen className="h-4 w-4" />} Ingresar
        </button>
      </div>
    </div>
    <button onClick={abrirHistorial} data-testid="abrir-historial-btn"
      className="w-full mt-3 h-11 inline-flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-wider text-white/50 hover:text-white border border-white/10 hover:border-white/30 transition-colors duration-200">
      <History className="h-4 w-4" /> Historial · Reimprimir comprobante
    </button>
  </div>
);

export default SalidaCobroPanel;
